import { addToCart } from '@hugh/cart-add';

/**
 * <hugh-bundle>: the bundle card of sections/hugh-pack-band.liquid. Its form adds both socks at
 * once (items[n][id], quantity 1 each) over AJAX through the shared add (assets/hugh-cart-add.js),
 * so the drawer opens with both lines. Without JS the form posts to /cart/add and opens the cart.
 */
class HughBundle extends HTMLElement {
  connectedCallback() {
    this.querySelector('form')?.addEventListener('submit', (event) => this.#add(event));
  }

  /** @param {SubmitEvent} event */
  async #add(event) {
    const form = event.currentTarget;
    if (!(form instanceof HTMLFormElement)) return;
    event.preventDefault();
    const button = this.querySelector('[data-bundle-add]');
    if (button?.getAttribute('aria-busy') === 'true') return;

    // Only whole variant ids at quantity 1 go to the cart.
    const body = new FormData(form);
    const lines = [];
    for (const [key, value] of body.entries()) {
      const match = key.match(/^items\[(\d+)\]\[id\]$/);
      if (!match) continue;
      if (!/^\d+$/.test(String(value))) return;
      body.set(`items[${match[1]}][quantity]`, '1');
      lines.push({ merchandiseId: String(value), quantity: 1 });
    }
    if (!lines.length) return;

    const status = this.querySelector('[data-bundle-status]');
    button?.setAttribute('aria-busy', 'true');
    try {
      const error = await addToCart(this, body, lines, 'bundle');
      if (status) status.textContent = error ? this.dataset.error || error : '';
    } catch {
      if (status) status.textContent = this.dataset.error || '';
    } finally {
      button?.removeAttribute('aria-busy');
    }
  }
}

if (!customElements.get('hugh-bundle')) customElements.define('hugh-bundle', HughBundle);
